'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/contexts/AuthContext'
import { OpasBrandLoading } from '@/components/branding/OpasBrandLoading'

export default function RootRedirect() {
  const { isAuthenticated, user, isLoading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (isLoading) return

    if (isAuthenticated && user?.role === 'superadmin') {
      router.replace('/sa-dashboard')
      return
    }

    const tenantId = typeof window !== 'undefined' ? localStorage.getItem('tenantId') : null
    if (tenantId) {
      router.replace('/t-dashboard')
      return
    }

    router.replace('/t-login')
  }, [isLoading, isAuthenticated, user, router])

  return <OpasBrandLoading variant="page" />
}
